import * as z from "zod";

export const ConnectionAlertDtoSchema = z
    .object({
        id: z.number(),
        hours_elapsed_to_trigger: z.number(),
        notify_all: z.boolean(),
        station_ids: z.array(z.number()),
        stations: z.record(z.string(), z.string().trim()),
        is_enabled: z.boolean().optional(),
    })
    .readonly();

export type ConnectionAlertDto = z.output<typeof ConnectionAlertDtoSchema>;

export const ConnectionAlertsDtoSchema = z
    .array(ConnectionAlertDtoSchema)
    .readonly();

export type ConnectionAlertsDto = z.output<typeof ConnectionAlertsDtoSchema>;

export interface ConnectionAlertUpdateBody {
    connection_alert: {
        hours_elapsed_to_trigger: number;
        notify_all: boolean;
        station_ids: number[];
        is_enabled: boolean;
    };
}
